import { render, staticRenderFns } from "./SupplierProfilePage.vue?vue&type=template&id=5a32b4bd&scoped=true&lang=pug&"
import script from "./SupplierProfilePage.vue?vue&type=script&lang=js&"
export * from "./SupplierProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierProfilePage.vue?vue&type=style&index=0&id=5a32b4bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a32b4bd",
  null
  
)

export default component.exports